import { SeriesJson } from "../componentes/SeriesJson";

export function SeriesLocale() {
  return <SeriesJson />;
}
